import React, {Suspense, lazy} from 'react';
import {authLoader} from '@app/navigations/loader';
import {Spin} from 'antd';
import {ROUTE_TENANT} from '@app/navigations/RoutePathConstant';

const Tenant = lazy(() =>
  import('../../../screens/Tenant')
    .then(module => ({default: module.Tenant})));

const TenantNavigation = [
  {
    path: ROUTE_TENANT,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <Tenant />
      </Suspense>
    ),
  },
];

export default TenantNavigation;
